module.exports = __webpack_public_path__ + "img/b6.013b4827.png";